export enum EFinanceCalculatingOrigin {
  PROGRAMMATICALLY = 'PROGRAMMATICALLY',
  USER_INPUT = 'USER_INPUT',
}
